export const savedReportTranslation = {
  overlay_text: 7486,
  submit: 7779,
  cancel: 3273,
  create_folder_button: 7786,
  create_folder_link: 7787,
  create_report_input_placeholder: 7788,
  copy: 7842,
  search_placeholder: 7557,
  link_to_report: 7781,
  share_with: 7784,
  title: 7775,
  users: 3650,
  user_group: 7843,
  owner: 6439,
  folder: 7841,
  report_title: 7778,
  succes_message_report: 7818,
  succes_message_folder: 7819,
  validation_error: 7702,
  no_options_found: 7644,
  page_of: 8454,
  must_be_filled: 7551,
  link_copy_success: 7826,
  link_copy_fail: 7825,
  done: 7338,
  copy_to_clipboard: 6438,
  saved_reports_title: 7827,
  back: 7518,
  move_report: 8200,
  move_folder: 8204,
  remove_report: 8160,
  confirm_remove: 8161,
  success_remove_report: 8162,
  success_remove_folder: 9372,
  remove_folder: 8165,
  confirm_remove_folder: 8166,
  search_required_message: 8146,
  update_report_title: 8322,
  update_report_button: 8323,
  edit_report: 8329,
  no_rights_to_edit_report: 9844,
  shared_report: 8358,
  shared_report_group: 8357,
  update_report_are_you_sure: 8324,
  update_report_other_users: 8335,
  update_report_not_undone: 8336,
  success_report_updated: 8334,
  shared: 8359,
  edit_folder: 8367,
  folder_title: 8368,
  save_folder: 8369,
  shared_folder_group: 8370,
  shared_folder_user: 8371,
  folder_updated: 8372,
  update_owners: 8373,
  share_contents: 8374,
  copy_sharing: 8375,
  saved_company_reports_title: 8788,
  save_new_company_report: 8787,
  update_existing_company_report: 8821,
  all_saved_reports_title: 8973,
  bookmark_report: 8974,
  remove_bookmark: 8975,
  no_bookmarked_reports: 8976,
  bookmark_folder: 8978,
  all_saved_company_reports_title: 8980,
  bookmarked_reports_title: 8981,
  bookmarked_company_reports_title: 8982,
  no_saved_reports: 8983,
  no_saved_company_reports: 8984,
  no_bookmarked_company_reports: 8993,
  toggle_between_reports_and_bookmarks: 9007,
  saved_dashboards_title: 9016,
  save_new_dashboard: 9015,
  update_existing_dashboard: 9017,
  all_saved_dashboards_title: 9018,
  bookmark_dashboard: 9019,
  no_bookmarked_dashboards: 9020,  
  bookmarked_dashboards_title: 9021,
  no_saved_dashboards: 9022,    
  toggle_between_dashboards_and_bookmarks: 9023,
  update_dashboard_are_you_sure: 9025,
  update_dashboard_other_users: 9026,
  update_dashboard: 9027,
  dashboard_title: 9028,
  link_to_dashboard: 9029,
  remove_dashboard: 9030,
  success_remove_dashboard: 9031,
  move_dashboard: 9032,
  edit_dashboard: 9033,
  save_dashboard: 9040,
  succes_message_dashboard: 9041,
  success_dashboard_updated: 9042,
  shared_dashboard: 9045,
  shared_dashboard_group: 9046,
  shared_dashboard_folder_group: 9047,
  confirm_remove_dashboard_folder: 9048,
  update_owners_dashboard: 9049,
  new_subfolder: 9070,
  copied_to_all_reports_in_current_folder: 9071,
  new_folder: 9073,
  create_new_folder: 9074,
  move: 9075,
  remove: 9076,
  create_new_subfolder: 9077,
  error_message_descendants_owner_not_updated: 9110,
  error_message_parent_owner_not_updated: 9138,
  open_as_administrator: 9226,
  success_move_report: 9368,
  success_move_folder: 9369
};

export const form = {
  title: 'title',
  folder: 'folder',
  owner: 'owner',
  user_group: 'user_group',
  users: 'users',
  link_to_report: 'link_to_report',
  create_folder_input: 'create_folder_input'
};

export const formFolder = {
  title: 'title',
  folder: 'folder',
  owner: 'owner',
  user_group: 'user_group',
  users: 'users',
  link_to_report: 'link_to_report',
  create_folder_input: 'create_folder_input',
  updateOwner: 'updateOwnerForAllDescendants',
  updateSharing: 'updateShareInformationForAllDescendants'
};

export const endpoint = {
  saveReport: 'favourite/definition',
  saveFolder: 'favourite/definition/folder',
  updateFolder: (folderId) => `favourite/definition/folder/${folderId}`,
  removeReport: (reportId) => `favourite/definition/${reportId}`,
  moveReport: (reportId:number) => `favourite/definition/${reportId}/parent`,
  loadOwnerOptions: 'favourite/definition/draft/options/owner',
  loadUsersOptions: 'favourite/definition/draft/options/users',
  loadUserGroupsOptions: 'favourite/definition/draft/options/userGroups',
  loadFolderOptions: 'user/current/options/folders',
  loadSavedReports: 'validFavourite',
  loadUsersMetadata: 'favourite/definition/draft/options/users/metadata',
  favouriteDefinition: 'favourite/definition/draft',
  loadBookmarkedSavedReports: 'validFavourite/bookmarks',
  manageBookmark: (favouriteId: number) => `validFavourite/bookmark/${favouriteId}`
};

export enum ReportId {
  CompanyReport = 11,
  Dashboard = 345
}

export const viewModeCacheKeySavedReports: string = 'savedReportsViewMode';
export const viewModeCacheKeySavedCompanyReports: string = 'savedCompanyReportsViewMode';
export const viewModeCacheKeySavedDashboards: string = 'savedDashboardsViewMode';
